import Main from '../../assets/js/modules/Main.js'
import Utils from '../../assets/js/modules/Utils.js'
import 'container-query-polyfill'

const modules = {
  HxpReactFactory: async () =>
    import(
      /* webpackChunkName: 'HxpReactFactory' */ `./factories/HxpReactFactory.js`
    ),
  UniversalSearchTypeaheadFactory: async () =>
    import(
      /* webpackChunkName: 'UniversalSearchTypeaheadFactory' */ `../../assets/js/factories/UniversalSearchTypeaheadFactory.js`
    ),
  QuickSearch: async () =>
    import(
      /* webpackChunkName: 'QuickSearch' */ `../../assets/js/modules/QuickSearch.js`
    ),
}

const hxpInstance = new Main(modules, Utils)
hxpInstance.init()
